import React, { useEffect, useState } from 'react';
import {
  TreeView,
  TreeViewExpandChangeEvent,
  TreeViewItemClickEvent,
  processTreeViewItems
} from '@progress/kendo-react-treeview';
import CustomTreeListItem from './CustomTreeListItem';
import { ITreeCategory } from '@Client/runner.services/runner.category-navigation.service';

type Props = {
  categories: ITreeCategory<any>[];
  categoryClicked(id: string, index: string, name: string, category: any): void;
  expandedCategory?: any;
  selectedCategoryId?: string;
};

const CategoryNavigation = (props: Props) => {
  const { categories, categoryClicked, selectedCategoryId, expandedCategory } =
    props;

  const [expandedCategories, setExpandedCategories] = useState({
    ids: [],
    idField: 'text'
  });
  // We shouldn't need currrentSelectedCategoryId at all, but the angular components
  // using this can't pass in updated selectedCategoryId,
  // because doing so recreates the entire CategoryNavigation component
  // and causes it to lose its scroll position and flicker.
  // TODO remove this once no angular components are using CategoryNavigation.
  const [currrentSelectedCategoryId, setCurrentSelectedCategoryId] = useState<
    string | null
  >(selectedCategoryId || (categories && categories[0]?.id) || null);

  useEffect(() => {
    if (expandedCategory !== null && expandedCategory?.ids?.length > 0) {
      setExpandedCategories((prevState) => ({
        ...prevState,
        ids: expandedCategory.ids
      }));
    }
  }, [expandedCategory]);

  useEffect(() => {
    if (
      currrentSelectedCategoryId === null &&
      categories &&
      categories.length > 0
    ) {
      setCurrentSelectedCategoryId(categories[0].id);
    }
  }, [categories, currrentSelectedCategoryId]);

  const handleItemClick = (event: TreeViewItemClickEvent) => {
    setCurrentSelectedCategoryId(event.item.id);
    categoryClicked(
      event.item.id,
      event.itemHierarchicalIndex,
      null,
      expandedCategories
    );
  };

  const onExpandChange = (event: TreeViewExpandChangeEvent) => {
    const ids = expandedCategories.ids.slice();
    const index = ids.indexOf(event.item.text);

    if (index === -1) {
      ids.push(event.item.text);
      expandAllChildren(event.item, ids);
    } else {
      ids.splice(index, 1);
    }

    setExpandedCategories({ ids, idField: 'text' });
  };

  const expandAllChildren = (category: any, expandedIds: string[]) => {
    if (category.items && category.items.length > 0) {
      category.items.forEach((child: any) => {
        expandedIds.push(child.text);
        expandAllChildren(child, expandedIds);
      });
    }
  };

  return (
    <div className="category-navigation">
      <div className="category-navigation-outer-container">
        <div className="category-navigation-container">
          <TreeView
            data={processTreeViewItems(categories, {
              select: {
                idField: 'id',
                ids: [currrentSelectedCategoryId]
              },
              expand: expandedCategories
            })}
            item={(props) => (
              <CustomTreeListItem
                {...props}
                isExpanded={expandedCategories.ids.includes(props.item.text)}
              />
            )}
            expandIcons={true}
            onExpandChange={onExpandChange}
            onItemClick={handleItemClick}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryNavigation;
